/**
 * TelemetryOverlay — subtle telemetry annotation overlay for Dark Factory.
 * Thin crosshair markers + tiny mono callouts at focal points on an industrial image.
 * Intentionally restrained — reads as machine-vision telemetry, not sci-fi.
 */
export default function TelemetryOverlay() {
  // Points defined in viewBox (100x100 relative) space.
  const points = [
    { x: 50, y: 52, label: "UNIT OP · 04", stat: "Δ 0.02σ" },
    { x: 76, y: 44, label: "VISION · 11", stat: "IN-SPEC" },
    { x: 24, y: 60, label: "AGV · R3", stat: "OK" },
  ];
  return (
    <svg
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      className="absolute inset-0 w-full h-full pointer-events-none"
      aria-hidden
    >
      {points.map((p, i) => (
        <g key={i}>
          {/* crosshair */}
          <line
            x1={p.x - 2.2}
            y1={p.y}
            x2={p.x + 2.2}
            y2={p.y}
            stroke="rgba(244,243,240,0.85)"
            strokeWidth="0.1"
            vectorEffect="non-scaling-stroke"
          />
          <line
            x1={p.x}
            y1={p.y - 2.2}
            x2={p.x}
            y2={p.y + 2.2}
            stroke="rgba(244,243,240,0.85)"
            strokeWidth="0.1"
            vectorEffect="non-scaling-stroke"
          />
          <circle
            cx={p.x}
            cy={p.y}
            r="1.1"
            fill="none"
            stroke="rgba(244,243,240,0.9)"
            strokeWidth="0.12"
            vectorEffect="non-scaling-stroke"
          />
          <circle
            cx={p.x}
            cy={p.y}
            r="0.28"
            fill="var(--g1-olive-muted)"
          />
          {/* leader line */}
          <line
            x1={p.x + 1.4}
            y1={p.y - 1.4}
            x2={p.x + 8}
            y2={p.y - 6}
            stroke="rgba(244,243,240,0.65)"
            strokeWidth="0.08"
            strokeDasharray="0.6 0.6"
            vectorEffect="non-scaling-stroke"
          />
          {/* callout — scaled up so text is readable */}
          <g transform={`translate(${p.x + 8.2} ${p.y - 6.4})`}>
            <text
              x="0"
              y="0"
              fill="rgba(244,243,240,0.85)"
              style={{
                font: '500 1.4px "IBM Plex Mono", monospace',
                letterSpacing: "0.1em",
                textTransform: "uppercase",
              }}
            >
              {p.label}
            </text>
            <text
              x="0"
              y="1.8"
              fill="rgba(224,227,218,0.9)"
              style={{
                font: '400 1.2px "IBM Plex Mono", monospace',
                letterSpacing: "0.12em",
                textTransform: "uppercase",
              }}
            >
              {p.stat}
            </text>
          </g>
        </g>
      ))}
    </svg>
  );
}
